<template>
  <div>
    <v-list>
      <v-subheader>Option d'impression</v-subheader>
      <v-list-tile
        @click="printDoc()">
        <v-list-tile-title>Imprimer</v-list-tile-title>  
      </v-list-tile>
      <v-list-tile
        @click="choixEtiquetteVisible = true">
        <v-list-tile-title>Choisir l'étiquette de départ</v-list-tile-title>
      </v-list-tile>
      <v-container v-if="choixEtiquetteVisible" class="mx-width">
        <v-layout column>
          <v-flex 
            v-for="(i,iIndex) in 5" 
            :key="iIndex">
            <v-layout row>
              <v-flex xs6
                v-for="(y,yIndex) in 2" 
                :key="yIndex">
                  <v-card 
                    color="primary"
                    ripple  
                    @click="printDoc(i+y+(i-2)-1)"
                    style="height:100px;"
                    class="ma-1 text-xs-center">
                    <v-layout align-center fill-height>
                      <v-card-text class="font-weight-bold">
                        {{i+y+(i-2)}}
                      </v-card-text>
                    </v-layout>
                  </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-list>
  </div>
</template>

<script>
import { print } from '@/utils/jsPDF'
export default {
  props: {
    idTournee: Number,
    etat: Boolean
  },
  data: () => ({
    choixEtiquetteVisible: false
  }),
  watch: {
    etat(val){
      if(val == false){
        this.choixEtiquetteVisible = false
      }
    }
  },
  methods: {
    printDoc(offset=0){
      const { details, datePassage, prochaineDate } = this.$store.getters.selectedTournee(this.idTournee)
      this.$emit('close-bottom')
      print({ 
              details, 
              datePassage, 
              prochaineDate,
              offset
            })

    }
  }
}
</script>

<style>
.mx-width{
  max-width: 500px;
}
</style>